<template>
  <div class="flex items-center">
      <font-awesome-icon :icon="['far', icon]" class="text-red-500" size="xs" />
      <router-link class="ml-2 text-red-500 " :to="to">
        <slot />
      </router-link>
    </div>
</template>

<script>
export default {
  name: 'icon-router-link',
  props: ['icon', 'to']
}
</script>